import { render, staticRenderFns } from "./TagCategory.vue?vue&type=template&id=0fa0b53e&scoped=true"
import script from "./TagCategory.vue?vue&type=script&lang=js"
export * from "./TagCategory.vue?vue&type=script&lang=js"
import style0 from "./TagCategory.vue?vue&type=style&index=0&id=0fa0b53e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa0b53e",
  null
  
)

export default component.exports